/* Booking hotel form - converted to Litepicker (was using dateRangePicker/moment)
   Behaviour preserved: visible label shows "DD MMM - DD MMM" and hidden inputs keep MM/DD/YYYY
*/

document.addEventListener('DOMContentLoaded', function () {
    // Booking Hotel Date Picker
    var bookingDateEls = document.querySelectorAll('.booking-hotel-date');
    if (bookingDateEls.length > 0) {
        // helper to format MM/DD/YYYY
        function fmtMMDDYYYY(d) { if (!d || isNaN(d.getTime())) return ''; return ('0' + (d.getMonth() + 1)).slice(-2) + '/' + ('0' + d.getDate()).slice(-2) + '/' + d.getFullYear(); }

        // Get yesterdays date
        var d = new Date();
        d.setDate(d.getDate() - 1); // Prevent selecting past dates

        bookingDateEls.forEach(function (bookingHotel) {
            try {
                if (typeof Litepicker === 'undefined') return;

                var startEl = bookingHotel.parentElement ? bookingHotel.parentElement.querySelector('#bookingHotelStartDate') : null;
                var endEl = bookingHotel.parentElement ? bookingHotel.parentElement.querySelector('#bookingHotelEndDate') : null;

                var picker = new Litepicker({
                    element: bookingHotel,
                    singleMode: false,
                    autoApply: true,
                    minDate: d, // Prevent selecting past dates
                    format: 'DD MMM YYYY'
                });

                // If there are hidden inputs with existing values (MM/DD/YYYY), set them as the initial range
                if (startEl && endEl && startEl.value && endEl.value) {
                    try {
                        var s = startEl.value.split('/');
                        var e = endEl.value.split('/');
                        var sDate = new Date(parseInt(s[2], 10), parseInt(s[0], 10) - 1, parseInt(s[1], 10));
                        var eDate = new Date(parseInt(e[2], 10), parseInt(e[0], 10) - 1, parseInt(e[1], 10));
                        try { picker.setDateRange(sDate, eDate); } catch (err) { /* ignore */ }

                        if (!isNaN(sDate.getTime()) && !isNaN(eDate.getTime())) {
                            bookingHotel.innerHTML = sDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + eDate.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
                        }
                    } catch (err) { /* ignore */ }
                }

                picker.on('selected', function (startDate, endDate) {
                    var sd = new Date(startDate.getTime());
                    var ed = new Date(endDate.getTime());

                    if (!isNaN(sd.getTime()) && !isNaN(ed.getTime())) {
                        bookingHotel.innerHTML = sd.toLocaleDateString(undefined, { day: '2-digit', month: 'short' }) + ' - ' + ed.toLocaleDateString(undefined, { day: '2-digit', month: 'short' });
                        if (startEl) startEl.value = fmtMMDDYYYY(sd);
                        if (endEl) endEl.value = fmtMMDDYYYY(ed);
                    } else {
                        bookingHotel.innerHTML = 'Choose a Date';
                        if (startEl) startEl.value = '';
                        if (endEl) endEl.value = '';
                    }
                });

            } catch (e) { console.error('Litepicker init error (booking-hotel)', e); }
        });

        // Sticky behaviour for the first booking form (preserved)
        window.addEventListener('scroll', function () {
            var firstHotelBookingForm = document.querySelector('.booking-hotel-form');
            if (!firstHotelBookingForm) return;
            var rect = firstHotelBookingForm.getBoundingClientRect();

            var breakPoint = rect.top + window.scrollY - 72; // We need to swap 72 out for whatever the header is

            if (window.scrollY >= breakPoint && !firstHotelBookingForm.classList.contains('sticky')) {
                firstHotelBookingForm.classList.add('sticky');
            } else if (window.scrollY < breakPoint && firstHotelBookingForm.classList.contains('sticky')) {
                firstHotelBookingForm.classList.remove('sticky');
            }
        });
    }

    // Booking Hotel Form - occupancy
    var bookingOccupancyEls = document.querySelectorAll('.booking-occupancy');
    if (bookingOccupancyEls.length > 0) {
        bookingOccupancyEls.forEach(function (bookingOccupancy) {
            var occupancyDropdown = bookingOccupancy.parentElement ? bookingOccupancy.querySelector('.occupancy-dropdown') : null;
            if (!occupancyDropdown) return;

            bookingOccupancy.addEventListener('click', function (event) {
                var isInside = event.target.closest('.occupancy-dropdown');
                if (!isInside) {
                    occupancyDropdown.classList.toggle('active');
                }
            });
        });
    }

    // When we click anything that is outside of the occupancy dropdown, we want to close it
    document.addEventListener('click', function (event) {
        var occupancyDropdowns = document.querySelectorAll('.occupancy-dropdown.active');
        occupancyDropdowns.forEach(function (dropdown) {
            var isInside = event.target.closest('.occupancy-dropdown') || event.target.closest('.booking-occupancy');
            if (!isInside) {
                dropdown.classList.remove('active');
            }
        });
    });

    function upDateOccupancyText(bookingOccupancy) {
        var occupancyDropdown = bookingOccupancy.parentElement ? bookingOccupancy.parentElement.querySelector('.occupancy-dropdown') : null;
        if (!occupancyDropdown) return;

        var roomsInput = occupancyDropdown.querySelector('select[name="Rooms"]');
        var adultsInput = occupancyDropdown.querySelector('select[name="adults"]');
        var childrenInput = occupancyDropdown.querySelector('select[name="children"]');
        var children2Input = occupancyDropdown.querySelector('select[name="child2"]');
        var children3Input = occupancyDropdown.querySelector('select[name="child3"]');

        var rooms = roomsInput ? parseInt(roomsInput.value, 10) : 0;
        var adults = adultsInput ? parseInt(adultsInput.value, 10) : 0;
        var children = childrenInput ? parseInt(childrenInput.value, 10) : 0;
        var children2 = children2Input ? parseInt(children2Input.value, 10) : 0;
        var children3 = children3Input ? parseInt(children3Input.value, 10) : 0;

        // Sum up all children inputs
        children += children2 + children3;

        // Update the visible text
        var text = '';
        if (rooms > 0) {
            text += rooms + ' Room' + (rooms > 1 ? 's' : '');
        }
        if (adults > 0 || children > 0) {
            if (text.length > 0) text += ', ';
        }
        if (adults > 0) {
            text += adults + ' Adult' + (adults > 1 ? 's' : '');
        }
        if (children > 0) {
            if (text.length > 0) text += ', ';
            text += children + ' Child' + (children > 1 ? 'ren' : '');
        }
        if (text.length === 0) {
            text = 'Select Occupancy';
        }

        var occupancyTextEl = bookingOccupancy.querySelector('.booking-ocupancy-text');
        if (occupancyTextEl) {
            occupancyTextEl.textContent = text;
        }
    }

    // Update the occupancy text on page load
    bookingOccupancyEls.forEach(function (bookingOccupancy) {
        upDateOccupancyText(bookingOccupancy);
    });

    // Update the occupancy text when inputs change
    var occupancyInputs = document.querySelectorAll('.occupancy-dropdown select');
    occupancyInputs.forEach(function (input) {
        input.addEventListener('change', function () {
            var bookingOccupancy = input.closest('form.booking-inline-widget-form').querySelector('.booking-occupancy');
            if (bookingOccupancy) {
                upDateOccupancyText(bookingOccupancy);
            }
        });
    });
});
